module.exports = __webpack_public_path__ + "static/media/ios-frame-home.de148689.png";